import { render, staticRenderFns } from "./OrganiserWizard.vue?vue&type=template&id=1ea15bd5&scoped=true&lang=pug"
import script from "./OrganiserWizard.vue?vue&type=script&lang=js"
export * from "./OrganiserWizard.vue?vue&type=script&lang=js"
import style0 from "./OrganiserWizard.vue?vue&type=style&index=0&id=1ea15bd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea15bd5",
  null
  
)

export default component.exports